import React from "react";
import { GlobalHeroCardStyles } from "../Styles";
import { Box } from "@mui/material";

const GlobalVideoCard = () => {
  return (
    <Box
      sx={[
        GlobalHeroCardStyles.HeroParentCard,
        {
          position: "relative",
          width: "100%",
          height: { xs: "200px", sm: "300px", md: "400px", lg: "400px" }, // Responsive heights
          // height: { xs: "200px", sm: "300px", md: "500px", lg: "600px" }, // Responsive heights
          overflow: "hidden",
        },
      ]}
    >
      <Box sx={GlobalHeroCardStyles.OverLayContainer} />

      <Box
        component="video"
        sx={{ width: "100%", height: "100%", objectFit: "cover" }}
        autoPlay
        loop
        muted
        playsInline
      >
        <source
          src={require("../../assets/video/CareerHeroVideo.mp4")}
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </Box>
    </Box>
  );
};

export default GlobalVideoCard;
